module.exports = __webpack_public_path__ + "static/img/Steven-May.e531e82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steven-May.jpg
// module id = OvHo
// module chunks = 0